export const STEP_TYPES = {
  garageType: 'garageType',
  automaticDoor: 'automaticDoor',
  montage: 'montage',
  houseType: 'houseType',
  colorsMaterials: 'colorsMaterials',
  houseStyle: 'houseStyle',
  areaOfUse: 'areaOfUse'
}

import {
  validateStepTypeGarageType,
  validateStepTypeAutomaticDoor,
  validateStepTypeMontage,
  validateStepTypeHouseType,
  validateStepTypeColorsMaterials,
  validateStepTypeHouseStyle,
  validateStepTypeAreaOfUse
} from '@/components/buy-guide/validate/validate-functions.js';

export const validateChoice = ({ step, choice }) => {
  // switch between validation functions based on step type.
  // console.log(step, choice)
  switch (step.Type) {
    case STEP_TYPES.garageType:
      return validateStepTypeGarageType({ choice })
    case STEP_TYPES.automaticDoor:
      return validateStepTypeAutomaticDoor({ choice })
    case STEP_TYPES.montage:
      return validateStepTypeMontage({ choice })
    case STEP_TYPES.houseType:
      return validateStepTypeHouseType({ choice })
    case STEP_TYPES.colorsMaterials:
      return validateStepTypeColorsMaterials({ choice })
    case STEP_TYPES.houseStyle:
      return validateStepTypeHouseStyle({ choice })
    case STEP_TYPES.areaOfUse:
      return validateStepTypeAreaOfUse({ choice })
    default:
      return null
  }
}
